/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CargCsclPrgsInfoDtlQryVo
 */
export interface CargCsclPrgsInfoDtlQryVo {
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    shedNm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    prcsDttm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    dclrNo?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    rlbrDttm?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    wght?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    rlbrBssNo?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    bfhnGdncCn?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    wghtUt?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    pckGcnt?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    cargTrcnRelaBsopTpcd?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    pckUt?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    rlbrCn?: string;
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoDtlQryVo
     */
    shedSgn?: string;
}

/**
 * Check if a given object implements the CargCsclPrgsInfoDtlQryVo interface.
 */
export function instanceOfCargCsclPrgsInfoDtlQryVo(value: object): value is CargCsclPrgsInfoDtlQryVo {
    return true;
}

export function CargCsclPrgsInfoDtlQryVoFromJSON(json: any): CargCsclPrgsInfoDtlQryVo {
    return CargCsclPrgsInfoDtlQryVoFromJSONTyped(json, false);
}

export function CargCsclPrgsInfoDtlQryVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CargCsclPrgsInfoDtlQryVo {
    if (json == null) {
        return json;
    }
    return {
        
        'shedNm': json['shedNm'] == null ? undefined : json['shedNm'],
        'prcsDttm': json['prcsDttm'] == null ? undefined : json['prcsDttm'],
        'dclrNo': json['dclrNo'] == null ? undefined : json['dclrNo'],
        'rlbrDttm': json['rlbrDttm'] == null ? undefined : json['rlbrDttm'],
        'wght': json['wght'] == null ? undefined : json['wght'],
        'rlbrBssNo': json['rlbrBssNo'] == null ? undefined : json['rlbrBssNo'],
        'bfhnGdncCn': json['bfhnGdncCn'] == null ? undefined : json['bfhnGdncCn'],
        'wghtUt': json['wghtUt'] == null ? undefined : json['wghtUt'],
        'pckGcnt': json['pckGcnt'] == null ? undefined : json['pckGcnt'],
        'cargTrcnRelaBsopTpcd': json['cargTrcnRelaBsopTpcd'] == null ? undefined : json['cargTrcnRelaBsopTpcd'],
        'pckUt': json['pckUt'] == null ? undefined : json['pckUt'],
        'rlbrCn': json['rlbrCn'] == null ? undefined : json['rlbrCn'],
        'shedSgn': json['shedSgn'] == null ? undefined : json['shedSgn'],
    };
}

export function CargCsclPrgsInfoDtlQryVoToJSON(json: any): CargCsclPrgsInfoDtlQryVo {
    return CargCsclPrgsInfoDtlQryVoToJSONTyped(json, false);
}

export function CargCsclPrgsInfoDtlQryVoToJSONTyped(value?: CargCsclPrgsInfoDtlQryVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shedNm': value['shedNm'],
        'prcsDttm': value['prcsDttm'],
        'dclrNo': value['dclrNo'],
        'rlbrDttm': value['rlbrDttm'],
        'wght': value['wght'],
        'rlbrBssNo': value['rlbrBssNo'],
        'bfhnGdncCn': value['bfhnGdncCn'],
        'wghtUt': value['wghtUt'],
        'pckGcnt': value['pckGcnt'],
        'cargTrcnRelaBsopTpcd': value['cargTrcnRelaBsopTpcd'],
        'pckUt': value['pckUt'],
        'rlbrCn': value['rlbrCn'],
        'shedSgn': value['shedSgn'],
    };
}

